import { MainLayout } from "components/layouts";
import EmployeeInfoGeneralProfile from "../components/EmployeeInfoGeneralProfile";
import useEmployeeGeneralInfo from "../hooks/useEmployeeGeneralInfo";

function EmployeeInfoGeneralInfoPage() {
  const useEmployeeGeneralInfoProps = useEmployeeGeneralInfo(false);

  return <MainLayout>
    <EmployeeInfoGeneralProfile {...useEmployeeGeneralInfoProps} />
  </MainLayout>;
}

export default EmployeeInfoGeneralInfoPage;
